
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 488.898 488.898"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M487.247 218.699c-17.9-168.2-171.6-228.2-269.4-217.5-72.9 8-137.3 47.9-177.9 109.2-6.2 9.4-4.2 21.8 5.2 28.1s21.8 3.1 28.1-6.2c34.3-51 88.4-84.3 148.8-90.5 103.6-10.7 203.6 52.4 224.7 181 15.5 94.4-58.6 212.6-181 224.7-74.6 7.4-147.3-25.9-189.4-86.5l38.5 8.5c10.4 2.1 21.8-4.2 23.9-15.6 2.1-10.4-4.2-21.8-15.6-23.9l-81.1-17.7c-5.2-1-22-.4-25 15.6l-16.6 82.2c-2.1 10.4 4.2 21.8 15.6 23.9 13 1.1 21.8-6.2 23.9-16.6l6.2-28.2c79.5 111.3 215.3 99.8 223.7 99 130.2-12.8 233.2-122.1 217.4-269.5z"}}),_c('path',{attrs:{"d":"M260.447 129.199c-11.4 0-20.8 9.4-20.8 20.8v94.7c0 5.2 2.1 10.4 6.2 14.6l94.7 94.7c12.2 11.6 25 4.2 30.2 1 8.3-8.3 8.3-20.8 0-29.1l-89.5-89.5v-86.3c.1-11.5-9.3-20.9-20.8-20.9z"}})])
          )
        }
      }
    